import { useCallback, useState } from 'react';
import { useSendVerificationEmailMutation } from '../auth/api';
import { useMeQuery } from '../profiles/api';

/**
 * "Confirm your email" (slice 4): resend the link, and say so plainly. It is
 * only ever a reward gate — nothing in the app waits on it.
 */
export function useResendVerification() {
  const { data: me } = useMeQuery();
  const [sendVerification, { isLoading }] = useSendVerificationEmailMutation();
  const [message, setMessage] = useState<string | null>(null);

  const send = useCallback(async () => {
    if (!me?.email || isLoading) return;
    setMessage(null);
    try {
      await sendVerification({ email: me.email }).unwrap();
      setMessage(`A fresh link is on its way to ${me.email}.`);
    } catch {
      setMessage('Could not send the link just now. Try again in a little while.');
    }
  }, [me?.email, isLoading, sendVerification]);

  return { send, sending: isLoading, message };
}
